import { render, staticRenderFns } from "./ProjectAdder.vue?vue&type=template&id=43d4e33a&scoped=true&"
import script from "./ProjectAdder.vue?vue&type=script&lang=js&"
export * from "./ProjectAdder.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAdder.vue?vue&type=style&index=0&id=43d4e33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4e33a",
  null
  
)

export default component.exports